import { forEach, isFunction } from 'lodash';
import { Observable, ReplaySubject } from 'rxjs';

import { PredicateFn } from '@geniuspos/ui-shared';

import { asObservable } from './common-utils';
import { ICheckerMap } from '../types/common/checker.type';
import { rx } from '../rx';

/**
 * get checker map from target
 *
 * @param targetList target object list
 * @param targetFieldPath which field you need to add to check,
 * judge priority is function,field obs value(`${targetFieldPath}Obs`), targetFieldValue asObservable
 * @returns target filed checkMap
 */
const getCheckerAndCheckerMap = <T extends {}, M extends keyof T>(
  targetList: T[],
  targetFieldPath: M,
): ICheckerMap<T> => {
  const checkerMap: ICheckerMap<T> = {
    checkers: [],
    map: new Map(),
  };

  forEach(targetList, (target) => {
    let checkResult$: Observable<boolean>;

    const targetFieldValue: boolean | PredicateFn<boolean> =
      target[targetFieldPath?.toString()];
    const targetFieldObsValue: Observable<boolean> =
      target[`${targetFieldPath?.toString()}Obs`];

    if (isFunction(targetFieldValue)) {
      const subj$ = new ReplaySubject<boolean>(1);
      const checker = (): void =>
        subj$.next((targetFieldValue as () => boolean)());
      checkerMap.checkers.push(checker);
      checkResult$ = subj$.pipe(rx.distinctUntilChanged());
    } else if (targetFieldObsValue) {
      checkResult$ = targetFieldObsValue;
    } else {
      // convert targetFieldValue to observable
      checkResult$ = asObservable(targetFieldValue);
    }

    checkerMap.map.set(target, checkResult$);
  });

  return checkerMap;
};

export { getCheckerAndCheckerMap };
